import {Stack, Box} from "@mui/material";
import {ProductStack} from "../../components/marketing/Products/ProductStack";
import React from "react";
import {selectProductCardPropsByIds} from "../../components/marketing/Products/productCatalogAdapter";

const BEANS_PRODUCTS_IDS = [
    "bean_charro",
    "bean_elote_pinto_black",
    "bean_mexican_black",
    "bean_refried_pinto",
    "bean_refried_ranchero"
];

export default function BeansSection() {
    const products = selectProductCardPropsByIds(BEANS_PRODUCTS_IDS);

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Box
                sx={{
                    width: "100%",
                    px: { xs: 2, sm: 3, md: 2, lg: 2, xl: 1 },
                    mx: "auto",
                }}
            >
                <ProductStack products={products} />
            </Box>
        </Stack>
    );
}
